/* Zeus About Page — V5A Shared JavaScript
   Works with Liquid section IDs via classes + data-* attributes. */
(function () {
  "use strict";

  var rm = window.matchMedia("(prefers-reduced-motion: reduce)");
  var flashInterval = 2800;

  window.__stormIntensityLightning = function (val) {
    flashInterval = 1600 + (1 - val) * 5000;
  };

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function bootAbout(root) {
    if (root.dataset.zeusAboutInit === "true") return;
    root.dataset.zeusAboutInit = "true";

    var hero = qs(".v4-hero", root) || root;
    initHeroVideo(hero);
    initLightning(hero);
    heroReveal(hero);
  }

  var gsapRetry = 0;
  function bootGSAP(root) {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      gsapRetry += 1;
      if (gsapRetry > 40) return; /* 8 s max : abandon propre, comme l'ancien garde-fou */
      setTimeout(function () {
        bootGSAP(root);
      }, 200);
      return;
    }
    initGSAP(root);
  }

  function boot() {
    document.querySelectorAll(".v4-hero").forEach(bootAbout);
    /* Root page-level : la stringer et les sections scrapbook/journey/eco sont
       des siblings de .v4-hero, pas des descendants. Un root .v4-hero rendrait
       tous les triggers GSAP non-hero muets (voir review Codex PR #345). */
    bootGSAP(document);
  }

  function killStaleTriggers(scope) {
    if (typeof ScrollTrigger === "undefined") return;
    ScrollTrigger.getAll().forEach(function (t) {
      var trig = t.trigger;
      if (!trig) return;
      var stale = !document.contains(trig) || (scope && scope.contains(trig));
      if (stale) t.kill();
    });
  }

  /* Ce module vit DANS la section about_hero (script src defer) : Shopify le
     re-execute a chaque re-render de section dans l'editeur. Le boot page et
     l'attachement de l'ecouteur doivent donc etre gardes SEPAREMENT :
     - boot page : une seule fois (sinon tous les ScrollTriggers globaux se
       dupliquent a chaque section:load) ;
     - ecouteur section:load : attache une seule fois, re-initialise les
       sections rechargees via la garde par element (root.dataset) — jamais de
       garde globale sur l'init des composants, sinon le nouveau DOM reste mort
       dans l'editeur. */
  if (!window.__zeusAboutPageBooted) {
    window.__zeusAboutPageBooted = true;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot);
    } else {
      boot();
    }
  }

  if (!window.__zeusAboutSectionBound) {
    window.__zeusAboutSectionBound = true;
    document.addEventListener("shopify:section:load", function (event) {
      var target = event && event.target ? event.target : document;
      if (!(target instanceof HTMLElement)) return;
      var hero = target.querySelector(".v4-hero");
      if (hero) bootAbout(hero);
      var hasAboutAnim = target.querySelector(
        "[data-about-stringer], [data-about-scrap-photo], [data-chapter], [data-panel], [data-journey-nav], [data-about-proof-count], [data-about-sparks], [data-about-marquee-track], [data-compass], [data-about-final-logo], .v4-community__mosaic, .v4-community__quote, .zeus-btn--magnetic",
      );
      if (hasAboutAnim) {
        killStaleTriggers(target);
        bootGSAP(target);
      }
    });
  }

  /* ---- Hero video: force Safari autoplay ---- */
  function initHeroVideo(hero) {
    var video = qs("[data-about-hero-video]", hero);
    var toggle = qs("[data-about-hero-toggle]", hero);
    if (!video || !toggle) return;

    var userPaused = false;
    var unlockBound = false;
    var forceTimer = null;

    function armMuted() {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.setAttribute("muted", "");
      video.playsInline = true;
      try {
        video.setAttribute("playsinline", "");
      } catch (e) {}
      try {
        video.setAttribute("webkit-playsinline", "");
      } catch (e) {}
    }

    function markPlaying() {
      toggle.setAttribute("data-paused", "false");
      toggle.setAttribute("aria-label", "Mettre la vidéo en pause");
      video.style.opacity = "1";
    }

    function markPaused() {
      toggle.setAttribute("data-paused", "true");
      toggle.setAttribute("aria-label", "Lire la vidéo");
    }

    function forcePlay() {
      if (rm.matches || document.hidden || userPaused) return Promise.resolve(false);
      armMuted();
      if (video.readyState === 0) {
        try {
          video.load();
        } catch (e) {}
      }
      var p = video.play();
      if (!p || typeof p.then !== "function") {
        if (!video.paused) markPlaying();
        return Promise.resolve(!video.paused);
      }
      return p
        .then(function () {
          markPlaying();
          return true;
        })
        .catch(function () {
          markPaused();
          return false;
        });
    }

    function kickSafari() {
      if (rm.matches || userPaused || document.hidden) return;
      var tries = 0;
      function tick() {
        tries += 1;
        forcePlay().then(function (ok) {
          if (ok || tries >= 12 || userPaused) return;
          forceTimer = setTimeout(tick, 280 + tries * 40);
        });
      }
      tick();
    }

    function bindGestureUnlock() {
      if (unlockBound) return;
      unlockBound = true;
      var unlock = function () {
        if (userPaused || rm.matches) return;
        armMuted();
        forcePlay();
      };
      ["pointerdown", "touchstart", "keydown", "wheel", "scroll"].forEach(function (evt) {
        window.addEventListener(evt, unlock, { capture: true, passive: true, once: true });
      });
    }

    function setState(paused) {
      if (paused) {
        video.pause();
        markPaused();
      } else {
        forcePlay().then(function (ok) {
          if (!ok) {
            bindGestureUnlock();
            kickSafari();
          }
        });
      }
    }

    function sync() {
      if (rm.matches || document.hidden || userPaused) {
        if (forceTimer) clearTimeout(forceTimer);
        setState(true);
      } else {
        setState(false);
      }
    }

    toggle.addEventListener("click", function () {
      userPaused = !video.paused;
      if (forceTimer) clearTimeout(forceTimer);
      setState(userPaused);
    });

    rm.addEventListener("change", sync);
    document.addEventListener("visibilitychange", sync);
    window.addEventListener("pageshow", function () {
      userPaused = false;
      sync();
    });

    video.style.opacity = "0.001";
    video.style.transition = "opacity 0.45s ease";
    ["loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing"].forEach(function (evt) {
      video.addEventListener(evt, function () {
        if (!userPaused && !rm.matches && !document.hidden) forcePlay();
        if (!video.paused) video.style.opacity = "1";
      });
    });

    armMuted();
    bindGestureUnlock();
    kickSafari();
    sync();
  }

  /* ---- Lightning flashes ---- */
  function initLightning(hero) {
    if (rm.matches) return;
    var bolts = qsa(".v4-hero__bolt-img", hero);
    var flash = qs("[data-about-hero-flash]", hero);
    if (!bolts.length) return;

    function flashRandom() {
      var idx = Math.floor(Math.random() * bolts.length);
      var bolt = bolts[idx];
      bolt.classList.add("is-flashing");
      if (flash) flash.classList.add("is-flashing");
      setTimeout(
        function () {
          bolt.classList.remove("is-flashing");
          if (flash) flash.classList.remove("is-flashing");
        },
        90 + Math.random() * 140,
      );
      setTimeout(flashRandom, flashInterval * (0.45 + Math.random()));
    }
    flashRandom();
  }

  /* ---- Hero scroll reveals (no GSAP) ---- */
  function heroReveal(hero) {
    var revealEls = qsa("[data-about-reveal]", hero);
    var titleLines = qsa(".v4-hero__title-line", hero);

    if (rm.matches) {
      revealEls.forEach(function (el) {
        el.style.opacity = "1";
        el.style.transform = "none";
      });
      titleLines.forEach(function (line) {
        line.style.opacity = "1";
        line.style.transform = "none";
        if (line.classList.contains("v4-hero__title-line--paper")) {
          line.classList.add("is-settled");
        }
      });
      var lc = qs(".v4-hero__lightning", hero);
      var fc = qs(".v4-hero__flash", hero);
      if (lc) lc.style.display = "none";
      if (fc) fc.style.display = "none";
      return;
    }

    revealEls.forEach(function (el) {
      var delay = parseInt(el.getAttribute("data-about-reveal") || "0", 10);
      setTimeout(function () {
        el.style.transition =
          "opacity 0.9s cubic-bezier(0.45,0.05,0.2,1), transform 0.9s cubic-bezier(0.45,0.05,0.2,1)";
        el.style.opacity = "1";
        el.style.transform = "translate(0, 0)";
      }, delay);
    });

    var titleDelay = [600, 700, 900];
    titleLines.forEach(function (line, i) {
      setTimeout(function () {
        line.style.transition =
          "opacity 0.7s cubic-bezier(0.45,0.05,0.2,1), transform 0.7s cubic-bezier(0.45,0.05,0.2,1)";
        line.style.opacity = "1";
        line.style.transform = "translate(0, 0)";
        if (line.classList.contains("v4-hero__title-line--paper")) {
          setTimeout(function () {
            line.classList.add("is-settled");
            line.style.transform = "";
          }, 720);
        }
      }, titleDelay[i] || 900);
    });
  }

  /* ---- GSAP + ScrollTrigger ---- */
  function initGSAP(root) {
    gsap.registerPlugin(ScrollTrigger);

    /* Stringer progress */
    var stringer = qs("[data-about-stringer]", root);
    var stringerFill = qs("[data-about-stringer-fill]", root);
    var stringerBolt = qs("[data-about-stringer-bolt]", root);
    if (stringerFill) {
      if (stringer) stringer.classList.add("is-visible");
      /* id fixe : le trigger stringer du boot page (trigger=document.body) n'est
         pas tue par killStaleTriggers (son trigger n'est pas dans le scope de la
         section rechargee). Sans kill par id, un re-render d'about_hero laissait
         deux triggers stringer actifs. */
      var prevStringer = ScrollTrigger.getById("zeus-about-stringer");
      if (prevStringer) prevStringer.kill();
      ScrollTrigger.create({
        id: "zeus-about-stringer",
        trigger: root === document ? document.body : root,
        start: "top top",
        end: "bottom bottom",
        onUpdate: function (self) {
          var pct = self.progress * 100;
          stringerFill.style.height = pct + "%";
          if (stringerBolt) {
            var boltY = (stringer.offsetHeight * Math.min(100, Math.max(0, pct))) / 100;
            stringerBolt.style.transform = "translate3d(-50%, calc(-50% + " + boltY + "px), 0)";
            stringerBolt.classList.toggle("is-active", pct > 2 && pct < 98);
          }
          if (window.__stormIntensityLightning) {
            window.__stormIntensityLightning(Math.max(0, 1 - self.progress * 1.8));
          }
        },
      });
    }

    /* Scrapbook photos */
    qsa("[data-about-scrap-photo]", root).forEach(function (photo) {
      var dir = photo.getAttribute("data-about-scrap-photo");
      gsap.from(photo, {
        scrollTrigger: { trigger: photo, start: "top 80%" },
        x: dir === "2" ? 60 : -80,
        rotation: dir === "2" ? 8 : -6,
        opacity: 0,
        duration: 0.9,
        ease: "power3.out",
        delay: dir === "2" ? 0.2 : 0,
      });
    });
    qsa(".v4-scrapbook__caption", root).forEach(function (cap) {
      gsap.from(cap, {
        scrollTrigger: { trigger: cap, start: "top 85%" },
        y: 30,
        opacity: 0,
        duration: 0.6,
        ease: "back.out(1.7)",
      });
    });

    /* Journey nav + panel sync */
    var chapterEls = qsa("[data-chapter]", root);
    var panels = qsa("[data-panel]", root);
    var navLinks = qsa("[data-journey-nav]", root);

    function activateChapter(name) {
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-panel") === name);
      });
      navLinks.forEach(function (l) {
        var active = l.getAttribute("data-journey-nav") === name;
        l.classList.toggle("is-active", active);
        if (active) l.setAttribute("aria-current", "step");
        else l.removeAttribute("aria-current");
      });
    }

    chapterEls.forEach(function (ch) {
      ScrollTrigger.create({
        trigger: ch,
        start: "top 55%",
        end: "bottom 45%",
        onEnter: function () {
          activateChapter(ch.getAttribute("data-chapter"));
        },
        onEnterBack: function () {
          activateChapter(ch.getAttribute("data-chapter"));
        },
      });
    });

    /* Count-up for 300+ */
    qsa("[data-about-proof-count]", root).forEach(function (proofCount) {
      if (rm.matches) return;
      var target = parseInt(proofCount.getAttribute("data-about-proof-count") || "300", 10);
      var countUp = { val: 0 };
      ScrollTrigger.create({
        trigger: proofCount,
        start: "top 85%",
        once: true,
        onEnter: function () {
          gsap.to(countUp, {
            val: target,
            duration: 2,
            ease: "power2.out",
            onUpdate: function () {
              proofCount.textContent = Math.round(countUp.val) + "+";
            },
          });
        },
      });
    });

    /* Ecosystem entries stagger */
    qsa(".v4-eco__entry", root).forEach(function (el, i) {
      gsap.from(el, {
        scrollTrigger: { trigger: el, start: "top 80%" },
        y: 60,
        opacity: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: "power3.out",
      });
    });

    /* Spark particles */
    if (!rm.matches) {
      qsa("[data-about-sparks]", root).forEach(function (sparkContainer) {
        for (var i = 0; i < 15; i++) {
          var spark = document.createElement("div");
          spark.className = "v4-eco__spark";
          spark.style.left = 10 + Math.random() * 80 + "%";
          spark.style.top = 5 + Math.random() * 90 + "%";
          sparkContainer.appendChild(spark);
          gsap.to(spark, {
            y: -(30 + Math.random() * 60),
            x: (Math.random() - 0.5) * 40,
            opacity: 0,
            duration: 2 + Math.random() * 3,
            repeat: -1,
            delay: Math.random() * 5,
            ease: "power1.out",
          });
        }
      });
    }

    /* Community mosaic + quote */
    qsa(".v4-community__mosaic", root).forEach(function (mosaic) {
      gsap.from(qsa("figure", mosaic), {
        scrollTrigger: { trigger: mosaic, start: "top 80%" },
        scale: 0.85,
        opacity: 0,
        duration: 0.6,
        stagger: 0.08,
        ease: "back.out(1.4)",
      });
    });
    qsa(".v4-community__quote", root).forEach(function (quote) {
      gsap.from(quote, {
        scrollTrigger: { trigger: quote, start: "top 85%" },
        y: 30,
        opacity: 0,
        duration: 0.7,
        ease: "power2.out",
      });
    });

    /* Marquee */
    qsa("[data-about-marquee-track]", root).forEach(function (marqueeTrack) {
      if (rm.matches) return;
      gsap.to(marqueeTrack, {
        x: -(marqueeTrack.scrollWidth / 2),
        duration: 30,
        repeat: -1,
        ease: "none",
      });
    });

    /* Compass chapters */
    qsa("[data-compass]", root).forEach(function (chapter) {
      var media = qs(".v5a-compass__media img, .v5a-compass__media video", chapter);
      var copy = qs(".v5a-compass__inner", chapter);
      if (media) {
        gsap.fromTo(
          media,
          { scale: 1.12 },
          {
            scale: 1,
            ease: "none",
            scrollTrigger: {
              trigger: chapter,
              start: "top bottom",
              end: "bottom top",
              scrub: true,
            },
          },
        );
      }
      if (copy) {
        gsap.from(copy.children, {
          scrollTrigger: { trigger: chapter, start: "top 70%" },
          y: 40,
          opacity: 0,
          duration: 0.75,
          stagger: 0.12,
          ease: "power2.out",
        });
      }
      var vid = qs("[data-compass-video]", chapter);
      if (vid && !rm.matches) {
        ScrollTrigger.create({
          trigger: chapter,
          start: "top 80%",
          end: "bottom 20%",
          onEnter: function () {
            vid.play().catch(function () {});
          },
          onEnterBack: function () {
            vid.play().catch(function () {});
          },
          onLeave: function () {
            vid.pause();
          },
          onLeaveBack: function () {
            vid.pause();
          },
        });
      }
    });

    /* Final section reveals */
    if (!rm.matches) {
      qsa("[data-about-final-logo]", root).forEach(function (finalLogo) {
        gsap.from(finalLogo, {
          scrollTrigger: { trigger: finalLogo, start: "top 85%" },
          scale: 0.3,
          opacity: 0,
          duration: 1.2,
          ease: "power3.out",
        });
      });
      qsa("[data-about-final-copy] h2", root).forEach(function (h2) {
        gsap.from(h2, {
          scrollTrigger: { trigger: h2, start: "top 80%" },
          y: 40,
          opacity: 0,
          duration: 0.8,
          ease: "power2.out",
          delay: 0.2,
        });
      });
      qsa("[data-about-final-actions]", root).forEach(function (actions) {
        gsap.from(actions, {
          scrollTrigger: { trigger: actions, start: "top 85%" },
          y: 30,
          opacity: 0,
          duration: 0.7,
          ease: "power2.out",
          delay: 0.4,
        });
      });
    }

    /* Magnetic button hover */
    qsa(".zeus-btn--magnetic", root).forEach(function (btn) {
      btn.addEventListener("mousemove", function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = "translate(" + x * 0.15 + "px, " + y * 0.15 + "px) scale(1.02)";
      });
      btn.addEventListener("mouseleave", function () {
        btn.style.transform = "translate(0, 0) scale(1)";
      });
    });

    if (typeof window.zeusScrollTriggerRefresh === "function") {
      window.zeusScrollTriggerRefresh();
    } else {
      ScrollTrigger.refresh();
    }
  }
})();
